import { __rest } from "tslib";
import * as React from 'react';
import LongArrowAltUpIcon from '@patternfly/react-icons/dist/esm/icons/long-arrow-alt-up-icon';
import LongArrowAltDownIcon from '@patternfly/react-icons/dist/esm/icons/long-arrow-alt-down-icon';
import ArrowsAltVIcon from '@patternfly/react-icons/dist/esm/icons/arrows-alt-v-icon';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Table/table';
import { TableText } from './TableText';
export var SortByDirection;

(function (SortByDirection) {
  SortByDirection["asc"] = "asc";
  SortByDirection["desc"] = "desc";
})(SortByDirection || (SortByDirection = {}));

export var SortColumn = function SortColumn(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isSortedBy = _a.isSortedBy,
      isSortedBy = _a$isSortedBy === void 0 ? false : _a$isSortedBy,
      _a$onSort = _a.onSort,
      onSort = _a$onSort === void 0 ? null : _a$onSort,
      _a$sortDirection = _a.sortDirection,
      sortDirection = _a$sortDirection === void 0 ? '' : _a$sortDirection,
      _a$type = _a.type,
      type = _a$type === void 0 ? 'button' : _a$type,
      props = __rest(_a, ["children", "className", "isSortedBy", "onSort", "sortDirection", "type"]);

  var SortedByIcon;

  if (isSortedBy) {
    SortedByIcon = sortDirection === SortByDirection.asc ? LongArrowAltUpIcon : LongArrowAltDownIcon;
  } else {
    SortedByIcon = ArrowsAltVIcon;
  }

  return React.createElement("button", Object.assign({}, props, {
    type: type,
    className: css(className, styles.tableButton),
    onClick: function onClick(event) {
      return onSort && onSort(event);
    }
  }), React.createElement("div", {
    className: css(className, styles.tableButtonContent)
  }, React.createElement(TableText, null, children), React.createElement("span", {
    className: css(styles.tableSortIndicator)
  }, React.createElement(SortedByIcon, null))));
};
SortColumn.displayName = 'SortColumn';